import { render } from "./QuotaUsageTab.vue?vue&type=template&id=b9240936&scoped=true"
import script from "./QuotaUsageTab.vue?vue&type=script&lang=js"
export * from "./QuotaUsageTab.vue?vue&type=script&lang=js"

import "./QuotaUsageTab.vue?vue&type=style&index=0&id=b9240936&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9240936"]])

export default __exports__